interface PlatformItem {
  label: string;
  mark: string;
  top: string;
  left: string;
  depth: 'near' | 'far';
  size: 'sm' | 'md' | 'lg';
  duration: number;
  delay: number;
}

const platforms: PlatformItem[] = [
  { label: 'ВКонтакте', mark: 'VK', top: '13%', left: '5%', depth: 'near', size: 'lg', duration: 24, delay: -2 },
  { label: 'VK Реклама', mark: 'Ads', top: '26%', left: '80%', depth: 'near', size: 'md', duration: 30, delay: -6 },
  { label: 'myTarget', mark: 'myT', top: '46%', left: '11%', depth: 'far', size: 'sm', duration: 34, delay: -3 },
  { label: 'Telegram', mark: 'TG', top: '64%', left: '86%', depth: 'near', size: 'md', duration: 27, delay: -8 },
  { label: 'Одноклассники', mark: 'OK', top: '72%', left: '6%', depth: 'near', size: 'md', duration: 31, delay: -5 },
  { label: 'Дзен', mark: 'Дз', top: '36%', left: '47%', depth: 'far', size: 'sm', duration: 38, delay: -9 },
  { label: 'Яндекс Директ', mark: 'Я', top: '84%', left: '28%', depth: 'far', size: 'sm', duration: 36, delay: -4 },
  { label: 'Avito', mark: 'A', top: '9%', left: '56%', depth: 'far', size: 'sm', duration: 33, delay: -7 },
];

const sizeClasses: Record<PlatformItem['size'], string> = {
  sm: 'gap-2 px-3 py-1.5 text-[11px]',
  md: 'gap-2 px-4 py-2 text-xs',
  lg: 'gap-2.5 px-5 py-2.5 text-sm',
};

const markSizeClasses: Record<PlatformItem['size'], string> = {
  sm: 'w-5 h-5 text-[9px]',
  md: 'w-6 h-6 text-[10px]',
  lg: 'w-7 h-7 text-[11px]',
};

export default function AdPlatformsBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden select-none"
    >
      {platforms.map((item) => {
        const isFar = item.depth === 'far';
        return (
          <div
            key={item.label}
            className="absolute"
            style={{
              top: item.top,
              left: item.left,
            }}
          >
            <div
              className={`flex items-center rounded-full border backdrop-blur-sm ${sizeClasses[item.size]} ${
                isFar
                  ? 'border-primary-700/15 bg-background-100/25 text-primary-300/45 blur-[1px]'
                  : 'border-primary-600/30 bg-background-100/50 text-primary-200/80'
              }`}
            >
              <span
                className={`flex-none flex items-center justify-center rounded-full font-heading font-bold ${markSizeClasses[item.size]} ${
                  isFar ? 'bg-primary-500/10 text-primary-300/60' : 'bg-primary-500/20 text-primary-200'
                }`}
              >
                {item.mark}
              </span>
              <span className="font-heading tracking-wide whitespace-nowrap">{item.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}